import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import { translate } from "../../../../../../../services/translation.service";
import theme from "../../../../../../../theme";

const Wrapper = styled.article`
  background-color: ${theme.colors.whiteSmoke};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 11px;
  padding: 0 45px;
`;

export default class HealthSection extends PureComponent {
  public render(): ReactNode {
    return (
      <Wrapper>
        <p>{translate("footer.alcoholAbuseIsDangerous")}</p>
      </Wrapper>
    );
  }
}
